/**
 * Green Lodging - Slider Initialization
 * Uses SwiperJS for carousel functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Travel Well Slider
    const travelWellSlider = document.querySelector('.gl-travel-well-slider');
    
    if (travelWellSlider) {
        new Swiper('.gl-travel-well-slider', {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            
            // Navigation arrows
            navigation: {
                nextEl: '.gl-travel-well-next',
                prevEl: '.gl-travel-well-prev',
            },
            
            // Pagination dots
            pagination: {
                el: '.gl-travel-well-pagination',
                clickable: true,
            },
            
            // Responsive breakpoints
            breakpoints: {
                // Mobile
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                // Tablet
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                // Small Desktop
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 24,
                },
                // Desktop
                992: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                },
                // Large Desktop
                1200: {
                    slidesPerView: 3.5,
                    spaceBetween: 32,
                },
                // XL Desktop
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                }
            }
        });
    }
    
    
    // Product Section Slider (Post Page)
    const productSlider = document.querySelector('.gl-post-products-slider');
    
    if (productSlider) {
        const productSwiper = new Swiper('.gl-post-products-slider', {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            
            // Navigation arrows
            navigation: {
                nextEl: '.gl-post-products-next',
                prevEl: '.gl-post-products-prev',
            },
            
            // Responsive breakpoints
            breakpoints: {
                // Mobile
                320: {
                    slidesPerView: 1.5,
                    spaceBetween: 12,
                },
                // Tablet
                576: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                // Small Desktop
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                // Desktop
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                // Large Desktop
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 28,
                },
                // XL Desktop
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                }
            },
            
            // Update slide count display
            on: {
                init: function() {
                    updateProductCount(this);
                },
                slideChange: function() {
                    updateProductCount(this);
                }
            }
        });
        
        function updateProductCount(swiper) {
            const countEl = document.querySelector('.gl-post-products-count');
            if (countEl) {
                const current = swiper.activeIndex + 1;
                const total = swiper.slides.length;
                countEl.textContent = `${current} / ${total}`;
            }
        }
    }
    
    // Destination Guides Slider
    const destinationGuidesSliders = document.querySelectorAll('.destination-guides-slider');
    
    if (destinationGuidesSliders.length > 0) {
        destinationGuidesSliders.forEach((slider) => {
            // Find the parent section to scope navigation buttons
            const section = slider.closest('.destination-guides');
            const prevButton = section ? section.querySelector('.destination-guides-prev') : null;
            const nextButton = section ? section.querySelector('.destination-guides-next') : null;
            const paginationEl = slider.querySelector('.destination-guides-pagination');
            
            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 24,
                loop: false,
                
                // Navigation arrows - scoped to this section
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                
                // Pagination dots
                pagination: {
                    el: paginationEl,
                    clickable: true,
                },
                
                // Responsive breakpoints
                breakpoints: {
                    // Mobile
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 16,
                    },
                    // Tablet
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    // Small Desktop
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 24,
                    },
                    // Desktop
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 28,
                    },
                    // Large Desktop
                    1200: {
                        slidesPerView: 3.2,
                        spaceBetween: 32,
                    },
                    // XL Desktop
                    1400: {
                        slidesPerView: 3.2,
                        spaceBetween: 32,
                    }
                }
            });
        });
    }



});

